import type { AffiliateTag } from 'tempest-common';
import type { CommerceInfoblockProps } from '@/components/raven/Commerce/CommerceInfoblock';
import type {
	CommerceOffer,
	SkimlinksWrapperConfig,
	TrackonomicsWrapperConfig,
} from '@themaven-net/commerce-shared';

export enum AffiliateTagLevel {
	/** Affiliate tag provided by unified config (site level) */
	Site,
	/** Affiliate tag set at post level */
	Post,
}

export type AffiliateTagWithLevel = {
	level: AffiliateTagLevel;
	value: AffiliateTag;
};

export type CommerceSiteConfig = {
	preferredAffiliates?: string[];
	preferredMerchants?: string[];
};

export type PhoenixCommerce = {
	preferredAffiliates?: string[];
	preferredMerchants?: string[];
};

/**
 * @todo Come back and look at custom data for GA events
 */
export type PhoenixTrackClickEvent = (
	anchor: HTMLAnchorElement,
	clickEvent: unknown,
) => object;

export interface CommerceConfigContextValues {
	affiliateTags?: AffiliateTagWithLevel[];
	amazonNca?: boolean;
	experiments?: string;
	permutive?: Permutive;
	phoenixTrackClickEvent?: PhoenixTrackClickEvent;
	phxCommerce?: PhoenixCommerce;
	skimlinks?: SkimlinksWrapperConfig;
	trackonomics?: TrackonomicsWrapperConfig;
	viewCorrelator?: string;
}

export type PermutiveCommerceAffiliateData = {
	affiliate?: string;
	campaign?: string;
	pageUrl: string;
	product: {
		categories?: Array<string>;
		name?: string;
		price?: {
			currency: string; // need clarification on the permitted values
			value: number;
		};
		productUrl: string;
	};
};

/**
 * Information about a commerce offer that can be useful for rendering a CTA
 *
 * The text property is optional as it may not exist for a specific offer, and
 * should instead use the default language.
 */
export type CommerceButtonRenderDetails = {
	offer: CommerceOffer;
	text?: string;
};

/**
 * Used to refer to commerce infoblocks in group contexts like the featured procducts carosel
 */
export type CommerceInfoblockPropsWithId = {
	id?: number;
} & CommerceInfoblockProps;
